import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { updateResidenceHistory } from '../../actions';
import { fetchStatesRequest } from '../../actions/fetchStatesActions';
import { longMonth } from '../../lib/dateFormatter';
import useCountries from '../../lib/hooks/useCountries';
import { subdivisionsSelector } from '../../reducers/selectors';
import IconDelete from '../Icons/IconDelete';
import IconEdit from '../Icons/IconEdit';
import ResidenceSelection from '../ResidenceSelection/ResidenceSelection';

const ResidenceHistoryItem = ({
  residenceHistoryItem,
  deleteResidence,
  stateName: title,
  isCurrentResidence,
  index,
  states,
  dispatchFetchStates,
  dispatchUpdateResidence,
}) => {
  const { stateCode, countryCode, startMonth, startYear } = residenceHistoryItem;

  const handleDeleteResidence = event => {
    deleteResidence(event.currentTarget.id);
  };
  const buttonId = `${countryCode}|${stateCode}`;

  const removeAriaLabel = `remove residence item`;

  const [editState, setEditState] = useState(false);
  const [initialCountry, setInitialCountry] = useState(null);
  const [initialState, setInitialState] = useState(null);
  const { data: countries } = useCountries();

  const fetchStatesForCountry = country => {
    dispatchFetchStates(country);
  };

  useEffect(() => {
    if (countryCode && !states[countryCode] && dispatchFetchStates)
      dispatchFetchStates(countryCode);
  }, [countryCode, states, dispatchFetchStates]);

  useEffect(() => {
    const countryStates = states[countryCode];
    if (countryStates) {
      const country = countries.find(country => country.value === countryCode);

      const stateLabel = countryStates.find(countryState => countryState.value === stateCode);
      setInitialCountry(country);
      setInitialState(stateLabel);
    }
  }, [countryCode, stateCode, states, countries]);

  const handleResidenceUpdate = payload => {
    dispatchUpdateResidence(payload);
  };

  return (
    <li className="item-box" aria-label={`residence item`}>
      {editState ? (
        <div className="no-top">
          <ResidenceSelection
            countries={countries}
            states={states}
            fetchStates={fetchStatesForCountry}
            updateResidence={handleResidenceUpdate}
            setEditState={setEditState}
            initialCountry={initialCountry}
            initialState={initialState}
            initialStartDate={{ year: startYear, month: startMonth }}
            index={index}
          />
        </div>
      ) : (
        <>
          {!index ? (
            <div>
              <p className="desktop-d4">Current Residence</p>
            </div>
          ) : (
            ''
          )}
          <div className="residence-wrapper">
            <div>
              <p className="item-box__title desktop-d-body">{title}</p>
              <p>{`Since ${longMonth(new Date(startYear, startMonth))}`}</p>
            </div>
            <div>
              {!isCurrentResidence && (
                <button
                  type="button"
                  onClick={handleDeleteResidence}
                  aria-label={removeAriaLabel}
                  id={buttonId}
                  className="delete-button"
                >
                  <IconDelete />
                </button>
              )}
            </div>
            <div>
              <button type="button" onClick={() => setEditState(true)}>
                <IconEdit />
              </button>
            </div>
          </div>
        </>
      )}
    </li>
  );
};

ResidenceHistoryItem.propTypes = {
  residenceHistoryItem: PropTypes.shape({
    stateCode: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    startMonth: PropTypes.number.isRequired,
    startYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  deleteResidence: PropTypes.func.isRequired,
  stateName: PropTypes.string.isRequired,
  isCurrentResidence: PropTypes.bool.isRequired,
  index: PropTypes.number,
  states: PropTypes.shape({}),
  dispatchFetchStates: PropTypes.func.isRequired,
  dispatchUpdateResidence: PropTypes.func.isRequired,
};

export const mapStateToProps = state => ({
  states: subdivisionsSelector(state),
});

export const mapDispatchToProps = {
  dispatchFetchStates: fetchStatesRequest,
  dispatchUpdateResidence: updateResidenceHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResidenceHistoryItem);
